import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';

import { ArenaService } from './arena.service';
import { access } from 'fs';

@Injectable()
export class ArenaOffersResolver implements Resolve<string> {

    constructor(
        private _arenaSrv: ArenaService
    ) {
    }

    async resolve(): Promise<any> {
        const offers = await this._arenaSrv.getOffers();

        return offers;
    }
}
